/* eslint-disable react-hooks/exhaustive-deps */
import ButtonWrapper from "../../../../shared/formUtilities/useButton";
import AddIcon from '@mui/icons-material/Add';
import { ComparisonService } from "../comparisonService";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useConfirm } from "material-ui-confirm";
import { InitializeComparisonColumns } from "./columns";
import { TableActionColumn } from "../../../../shared/components/common/tableActionColumn";
import { ActionButtons } from "../../../../constants/actionButtons";
import { buildRegionizeRoute } from "../../../../helpers/regionRouteHelper";
import { AppRoutes } from "../../../../constants/appRoutes";
import DataTableGrid from "../../../../shared/formUtilities/useTable";

export const ComparisonList = () => {
  const comparisonService = new ComparisonService();
  const queryParameters = new URLSearchParams(window.location.search);
  const [comparisons, setComparisons] = useState([]);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageCount: 0,
    perPage: 10,
    totalCount: 0,
  });
  const confirm = useConfirm();
  const columns = [
    ...InitializeComparisonColumns(),
    TableActionColumn({
      visibleActionsList: [ActionButtons.Edit, ActionButtons.Delete],
      onEdit: (e, row) => {
        onEdit(e, row);
      },
      onDelete: (e, row) => {
        onDelete(row);
      },
    }),
  ];

  const onEdit = (e, row) => {
    e.stopPropagation();
    navigate(
      buildRegionizeRoute(
        `${AppRoutes.CompetitorsComparisons}/edit/${row?.id}`
      )
    );
  };

  const onDelete = (row) => {
    confirm({
      description: `Are you sure you want to delete this review?`,
      title: 'Confirm!',
      confirmationButtonProps: {
        className: '!bg-red-500 !text-white !capitalize',
      },
      confirmationText: 'Delete',
      cancellationButtonProps: { className: '!capitalize' },
    })
      .then(() => {
        setloading(true);
        comparisonService
          .deleteComparison(row?.id)
          .then((resp) => {
            getComparisons();
          })
          .catch((err) => {
            setloading(false);
          });
      })
      .catch(() => console.log('cancelled.'));
  };

  const onAdd = () => {
    navigate(
      buildRegionizeRoute(`${AppRoutes.CompetitorsComparisons}/create`)
    );
  };


  function onNavigate(currentPage, perPage) {
    navigate({
      pathname: buildRegionizeRoute(
        `${AppRoutes.CompetitorsComparisons}`
      ),
      search: `?currentPage=${currentPage}&perPage=${perPage}`,
    });
  }

  useEffect(() => {
    getComparisons();
  }, [
    queryParameters.get('currentPage'),
    queryParameters.get('perPage'),
    window.location.search,
  ]);

  const getComparisons = () => {
    setloading(true);
    let currentPage = queryParameters.get('currentPage')
      ? parseInt(queryParameters.get('currentPage'))
      : 1;
    let perPage = queryParameters.get('perPage')
      ? parseInt(queryParameters.get('perPage'))
      : 10;
    comparisonService
      .getAllComparison(currentPage, perPage)
      .then((resp) => {
        setPagination({
          pageCount: resp.data.paging?.totalCount,
          currentPage: resp.data.paging?.currentPage,
          perPage: resp.data.paging?.perPage,
          totalCount: resp.data.paging?.totalCount,
        });
        setloading(false);
        setComparisons(resp.data.competitorComparisons);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  const onPageSizeChange = (e) => {
    onNavigate(1, e);
  };

  const onPageChange = (e) => {
    onNavigate(e + 1, pagination.perPage);
  };
  return (
    <>
      <DataTableGrid
        columnPinning={['action']}
        actionButtons={
          <ButtonWrapper
            disabled={loading}
            onClick={() => onAdd()}
            label={'Create'}
            icon={<AddIcon />}></ButtonWrapper>
        }

        name={'comparisonsTbl'}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        columns={columns}
        heading={'Reviews'}
        records={comparisons}
        pagination={pagination}
        showEditColumnsButton={true}
        loading={loading}></DataTableGrid>
    </>
  );
};